// import external dependencies
import 'jquery';

// import mmenu
// import 'jquery.mmenu/dist/jquery.mmenu.all.js';
import 'jquery.mmenu';
// import 'jquery.mmenu/dist/jquery.mmenu.all.css';

// import Slick
// import 'slick-carousel/slick/slick.min';
import 'slick-carousel';
// import 'slick-carousel/slick/slick.css';

import Cookies from 'js-cookie';

// import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateLocations from './routes/templateLocations';
import blog from './routes/blog';

(function($) {
var cookieName = "topalert";
  if ($('#topNotice').length) { // only run if on the page
    var cookieDoesntExist = Cookies.get(cookieName) === undefined;
    if (cookieDoesntExist) {
      $("#topNotice").show();
      $("#topNotice .close").click(function() {
        // 1 Day from now
        Cookies.set(cookieName, true, { expires: 1 });
      });
    }
  }
})(jQuery);

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Locations Page, used for the Location Finder
  templateLocations,
  // In the news page
  blog,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Common data layer code for pushing form paging events to Google Tag Manager
function formPagingEvent(form_id, page_number){
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "form_paging",
    form_id: form_id,
    page_number: page_number,
  });
}

// Track form paging with data layer events
$(document).on('gform_post_render', function(event, form_id, current_page){
  // console.log(current_page);

  // This event fires when the page of the form is rendered
  // Since the page of the form is re-rendered when there are validation errors, we won't trigger the paging event
  // Don't fire paging event for page 1 since we will use a form_start event
  // current_page will be 'undefined' on last page when form is submitted
  if(!$('.gform_validation_errors').length && typeof current_page !== 'undefined' && current_page != 1){
    // console.log(['paging', current_page]);

    formPagingEvent(form_id, current_page);
  }
});

// Open modal when URL contains fragment/anchor/hash
// e.g. https://www.bayshore.ca/contact-us/#contactForm
$(function () {
  function openModalFromUrlFragment() {
    var fragment = window.location.hash;

    if (!fragment) return;

    var $modal = $(fragment);

    // Make sure Bootstrap modal exists
    if ($modal.length && $modal.hasClass('modal')) {
      $modal.modal('show');
    }

    // Remove URL fragment when modal closes
    $modal.on('hidden.bs.modal', function () {
      // Make sure URL fragment matches
      if (window.location.hash === fragment) {
        history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    });
  }

  // Run on page load
  openModalFromUrlFragment();

  // Run when URL fragment changes (manual edit, JS, etc.)
  $(window).on('hashchange', function () {
    openModalFromUrlFragment();
  });

  // Run when using back/forward
  // Disabled for now because this may not be the desired UX.
  // i.e. If user closes the modal and goes back, they may prefer it be closed.
  // window.addEventListener('pageshow', function () {
  //   openModalFromUrlFragment();
  // });
});